<div class="container">
  <div class="container-content ui-page-shell-modern">
    <ng-container>
      <app-esteira-list></app-esteira-list>
    </ng-container>
  </div>
</div>
